export const colorTemplates = [
  {
    id: "template1",//done
    name: "Black & White",
    colors: {
      slide_background: "#F8FAFC",
      heading_color: "#0D0D0D",
      normal_text: "#475569",
      vertical_line: "#262626",
      horizontal_line: "#404040",
      accent_text: "#FFFFFF",
      accent_bg: "#262626",
      first_pg_odd_bg: "#404040",
      link: "#FFFFFF",
      Second_pg_odd_text: "#FFFFFF",
      Second_pg_odd_bg: "#CBCBCB",
      Second_pg_even_text: "#FFFFFF",
      Second_pg_even_bg: "#E7E7E7",
    },
  },
  {
    id: "template2",//done
    name: "Clinical Infrastructure",
    colors: {
      slide_background: "#F8FAFC",
      heading_color: "#247b86",
      normal_text: "#475569",
      vertical_line: "#247b86",
      horizontal_line: "#32abb8",
      accent_text: "#FFFFFF",
      accent_bg: "#247b86",
      first_pg_odd_bg: "#32abb8",
      link: "#FFFFFF",
      Second_pg_odd_text: "#000000",
      Second_pg_odd_bg: "#f8fafc",
      Second_pg_even_text: "#000000",
      Second_pg_even_bg: "#f2f2f2",
    },
  },
  {
    id: "template3",
    name: "Obsidian Executive",
    colors: {
      slide_background: "#F8FAFC",
      heading_color: "#25393A",
      normal_text: "#475569",
      vertical_line: "#2A3E3F",
      horizontal_line: "#2A3E3F",
      accent_text: "#FFFFFF",
      accent_bg: "#2A3E3F",
      first_pg_odd_bg: "#4B767F",
      link: "#404040",
      Second_pg_odd_text: "#0F172A",
      Second_pg_odd_bg: "#F3F7F7",
      Second_pg_even_text: "#0F172A",
      Second_pg_even_bg: "#F2F2F2",
    },
  },
  // {
  //   id: "template4",
  //   name: "Electric Blueprint",
  //   colors: {
  //     slide_background: "#0F172A",
  //     heading_color: "#38BDF8",
  //     normal_text: "#94A1B8",
  //     vertical_line: "#818CF8",
  //     horizontal_line: "#1E293B",
  //     accent_text: "#F8FAFC",
  //     accent_bg: "#1E293B",
  //     first_pg_odd_bg: "#334155",
  //     link: "#0EA5E9",
  //     Second_pg_odd_text: "#BAE6FD",
  //     Second_pg_odd_bg: "#1E293B",
  //     Second_pg_even_text: "#64748B",
  //     Second_pg_even_bg: "#1E293B",
  //   },
  // },
];

export const mapTemplateColorsToThemeSettings = (colors) => ({
  slide_background: colors.slide_background,
  header_color: colors.heading_color,
  accent_color: colors.vertical_line,
  right_card_bg: colors.accent_bg,
  right_card_row_odd: colors.accent_bg,
  right_card_row_even: colors.first_pg_odd_bg,
  right_card_title_clr: colors.accent_text,
  right_card_label_clr: colors.accent_text,
  right_card_value_clr: colors.Second_pg_odd_text,
  right_card_link_clr: colors.link,
  na_yellow: colors.accent_text,
  text_dark: colors.heading_color,
  text_mid: colors.normal_text,
  text_gray: colors.normal_text,
  blue_link: colors.link,
  navy: colors.accent_bg,
  navy_mid: colors.horizontal_line,
  navy_light: colors.vertical_line,
  custom_blue: colors.horizontal_line,
  white: colors.slide_background,
  light_bg: colors.Second_pg_odd_bg,
});

export const mapThemeSettingsToTemplateColors = (themeSettings) => ({
  slide_background: themeSettings.slide_background,
  heading_color: themeSettings.header_color,
  normal_text: themeSettings.text_mid,
  vertical_line: themeSettings.accent_color,
  horizontal_line: themeSettings.navy_mid,
  accent_text: themeSettings.right_card_title_clr,
  accent_bg: themeSettings.right_card_bg,
  first_pg_odd_bg: themeSettings.right_card_row_odd,
  link: themeSettings.blue_link,
  Second_pg_odd_text: themeSettings.right_card_value_clr,
  Second_pg_odd_bg: themeSettings.right_card_row_even,
  Second_pg_even_text: themeSettings.text_gray,
  Second_pg_even_bg: themeSettings.light_bg,
});

export const templateColorsMatch = (leftColors, rightColors) =>
  Object.keys(leftColors).every(
    (key) => String(leftColors[key]).toLowerCase() === String(rightColors[key]).toLowerCase()
  );

export const defaultThemeSettings = {
  enterprise_name: "",
  logo_path: "",
  logo_key: "",
  enable_logo: true,
  slide_background: "#FFFFFF",
  header_color: "#003374",
  accent_color: "#2F83F6",
  right_card_bg: "#003374",
  right_card_row_odd: "#034889",
  right_card_row_even: "#003374",
  right_card_title_clr: "#FFFFFF",
  right_card_label_clr: "#FFFFFF",
  right_card_value_clr: "#D0E4FF",
  right_card_link_clr: "#ADD8FF",
  na_yellow: "#FFE599",
  text_dark: "#0F172A",
  text_mid: "#475569",
  text_gray: "#94A1B8",
  blue_link: "#2563EB",
  navy: "#003A78",
  navy_mid: "#0A4A92",
  navy_light: "#3769A8",
  custom_blue: "#156082",
  white: "#FFFFFF",
  light_bg: "#F8FAFC",
  primary_font: "Calibri",
  header_font: "Calibri",
  footer_font: "Calibri",
  footer_font_size: 9,
  confidential_text: "Confidential  |  2026",
  enable_footer: true,
  enable_confidential: true,
};

export const defaultThemeTemplate = {
  id: "default",
  name: "Default Theme",
  colors: mapThemeSettingsToTemplateColors(defaultThemeSettings),
};

export const fontOptions = ["Calibri", "Arial", "Roboto", "Inter"];

export const customTemplateSections = [
  {
    id: "theme-colors",
    title: "Template Colors",
    icon: "bi-palette",
    columns: "col-md-4",
    fields: [
      { label: "Slide Background", key: "slide_background" },
      { label: "Heading Color", key: "heading_color" },
      { label: "Normal Text", key: "normal_text" },
      { label: "Vertical Line", key: "vertical_line" },
      { label: "Horizontal Line", key: "horizontal_line" },
      { label: "Accent Text", key: "accent_text" },
    ],
  },
  {
    id: "card-mapping",
    title: "Card Mapping Colors",
    icon: "bi-card-text",
    columns: "col-md-3",
    fields: [
      { label: "Accent BG", key: "accent_bg" },
      { label: "First Page Odd BG", key: "first_pg_odd_bg" },
      { label: "Link", key: "link" },
      { label: "Second Page Odd Text", key: "Second_pg_odd_text" },
      { label: "Second Page Odd BG", key: "Second_pg_odd_bg" },
      { label: "Second Page Even Text", key: "Second_pg_even_text" },
      { label: "Second Page Even BG", key: "Second_pg_even_bg" },
    ],
  },
];
